import Echo from "laravel-echo"
import store from './store/store'
import axios from 'axios'

window.Pusher = require('pusher-js');

let websock = {
  init: function () {
    console.log('initialisation pusher')
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'jtyrthgerg',
      wsHost: process.env.VUE_APP_WS_HOST,
      wsPort: process.env.VUE_APP_WS_PORT,
      disableStats: true,
      encrypted: false,
      forceTLS: process.env.NODE_ENV === 'production',
      authorizer: (channel, options) => {
        return {
          authorize: (socketId, callback) => {
            console.log('ici')
            axios.post('broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name
            }, {baseURL: window.host || '/'})
              .then(response => {
                callback(false, response.data);
              })
              .catch(error => {
                callback(true, error);
              });
          }
        };
      },
    });

    let user = store.getters['user']
    console.log('pusher user', user)
    window.Echo.private(`message.${user.id}`)
      .listen('DiscussionMessageEvent', (e) => {
        store.commit('chat/APPEND_MESSAGE', e.chat)
      })

  }
}
export default websock
